<template>
  <el-row class="editPanel">
    <h3 :class="{closed: !panelOpen}">Comments</h3><span class="toggle" @click="panelOpen = panelOpen !== true" :class="{closed: !panelOpen}"></span>
    <transition name="panel">
      <div class="pea-panel" v-if="panelOpen">
        <el-row>
          <el-col :span="24">
            <el-table
             :data="tableData"
             stripe
             v-loading="tableLoading"
             >
             <el-table-column align="left"
               prop="createdDate"
               label="Date/Time(EST)">
               <template slot-scope="props">
                {{ getCreatedDate(props.row) }}
               </template>
             </el-table-column>
             <el-table-column align="left"
               prop="userName"
               label="Author">
             </el-table-column>
             <el-table-column align="left"
               prop="comment"
               label="Comment">
             </el-table-column>
            </el-table>
            <el-pagination v-if="resultTotal > pageSize"
              @current-change="fetchData"
              :current-page.sync="currentPage"
              :page-size="pageSize"
              layout="total, prev, pager, next"
              :total="resultTotal">
            </el-pagination>
          </el-col>
        </el-row>
        <br />
        <el-row :gutter="20" class="addCommentRow" v-if="!isLoading && !disabled">
          <el-form ref="commentForm" :model="newCommentObject" :rules="rules">
              <el-form-item prop="comment">
                <el-input type="textarea" :disabled="disabled" v-model="newCommentObject.comment" :canEdit="true" :minlength="3" :maxlength="200" :autosize="{ minRows: 1, maxRows: 4}"></el-input>
              </el-form-item>
              <div v-if="isLoading">
                Submit Processing...
              </div>
              <el-button  :disabled="disabled" type="primary" @click="addComment()">Add Comment</el-button>
            <el-col :lg="1">
              <tool-tip-popup :text="commentToolTipText" :showLink="true"></tool-tip-popup>
            </el-col>
          </el-form>
          <br/>
        </el-row>
      </div>
    </transition>
  </el-row>
</template>
<script>
import helperMethods from '@/components/utility/helperMethods.js'
export default {
  name: 'pea-comment',
  props: {
    peaId: {
      default: 0
    },
    disabled: {
      default: false
    }
  },
  data () {
    return {
      commentToolTipText: 'Note: To add a comment you must first type it into the text area provided and then press the Add Comment button.<br/>Maximum length is 200 characters.',
      tableData: [{}],
      currentPage: 1,
      pageSize: 5,
      resultTotal: 0,
      isLoading: false,
      newCommentObject: {
        comment: '',
        peaId: this.peaId
      },
      rules: {
        comment: [
          { required: true, message: 'Please input comment to add comment', trigger: 'change' },
          { min: 3, max: 5550, message: 'Length should be 3 to 5550 characters to add comment', trigger: 'change' }
        ]
      },
      panelOpen: true,
      tableLoading: true
    }
  },
  methods: {
    fetchData: function () {
      this.tableLoading = true
      var call = '/getCommentList/' + this.peaId + '?page=' + this.currentPage + '&pageSize=' + this.pageSize
      this.$axios.get(call).then(response => {
        this.tableData = response.data.results
        this.resultTotal = response.data.totalRecords
        this.tableLoading = false
        this.$emit('fetchComplete')
      }).catch(reject => {
        this.tableLoading = false
        this.tableData = null
        this.resultTotal = 0
        helperMethods.showNotification(this.$parent, 'Error retrieving PEA Comments', reject.body, 'error', 30000)
      })
    },
    addComment: function () {
      this.isLoading = true
      this.$refs['commentForm'].validate((valid) => {
        if (valid) {
          var call = '/addPEAComment/' + this.peaId
          this.$axios.post(call, this.newCommentObject).then(data => {
            this.isLoading = false
            this.newCommentObject.comment = ''
            this.fetchData()
            helperMethods.showNotification(this.$parent, 'Comment Successfully saved', 'Comment added to PEA', 'success', 10000, '')
          }).catch(reject => {
            this.isLoading = false
            helperMethods.showNotification(this.$parent, 'Error Adding Comment', reject.body, 'error', 30000, '')
          })
        } else {
          this.isLoading = false
          helperMethods.showNotification(this.$parent, 'Error Adding Comment', 'Please add Comment text', 'warning', 10000, '')
          return false
        }
      })
    },
    getCreatedDate: function (entry) {
      return helperMethods.formatDate(entry.createdDate)
    },
    startUp () {
      // eslint-disable-next-line
      if (this.peaId != 0) {
        this.fetchData()
      } else {
        this.tableData = null
      }
    }
  },
  mounted () {
    this.startUp()
  },
  watch: {
    // watch for route change - going from pea/4 to pea/0
    '$route': 'startUp'
  }
}
</script>

<style scoped>
.wrap div{
    white-space: -o-pre-wrap !important;
    word-wrap: break-word !important;
    white-space: pre-wrap !important;
    white-space: -moz-pre-wrap !important;
    white-space: -pre-wrap !important;
}

.addCommentRow {
  padding: 0 10px;
}

.addCommentRow form {
  display: flex;
  align-items: center;
  /*justify-content: space-between;*/
}

.addCommentRow div {
  margin: 0;
}

.addCommentRow .el-textarea {
  width: 500px;
  margin-right: 20px;
}
</style>
